module.exports = {
  getData() {
    return {};
  },
};
